import { ENV } from '@environment';

export const reservationImageByDestination = (code: string): string => {
  const name = `dest-${code.toLowerCase()}.jpg`;
  const folder = 'web/travel/destinations';
  return `${ENV.API.RAPPI_IMAGES_CDN}${folder}/${name}`;
};
export const reservationCompanyImage = (airlineCode: string): string => {
  const name = `${airlineCode}.png`;
  const folder = 'web/travel/airlines';
  return `${ENV.API.RAPPI_IMAGES_CDN}${folder}/${name}`;
};
